import { getUser } from '@/utils/api';

const DemoBanner = () => {
  const user = getUser();
  if (user?.role !== 'demo') return null;
  return (
    <div
      className="bg-amber-100 border-b border-amber-300 text-amber-800 text-sm text-center py-2 px-4"
      data-testid="demo-banner"
    >
      Demo Mode — Sample data only. Editing is disabled.
    </div>
  );
};

export default DemoBanner;
